<template>
  <div class="party-banner">
    <img :src="partyBanner" alt="" />
  </div>
</template>

<script>
import { reactive } from "vue";

import partyBanner from "../../../assets/party/partyBanner.png";

export default {
  setup() {
    return reactive({
      partyBanner: partyBanner,
    });
  },
};
</script>

<style scoped>
@media screen and (max-width: 1180px) {
  .party-banner {
    min-width: 1180px;
  }
}
.party-banner img {
  width: 100%;
  height: 628px;
}
</style>
